import * as React from 'react';
import { observer } from 'mobx-react';
import { PagingStore } from '../../../store/paging-store/paging-store';
import PagingRecordsCounts from './paging-records';
import PagingPages from './paging-pages';
import { ONE, ZERO } from '../../../constans/common-constants';
import './paging.scss';

interface IProps {
  pagingStore: PagingStore;
  onSelectPageCallback?: () => void;
}

const Paging: React.FC<IProps> = ({ pagingStore, onSelectPageCallback }) => {
  const {
    getTotalPages,
    getCurrentPage,
    getTotalRecords,
    getPageSize,
  } = pagingStore;

  const needToShowPagingList = getTotalPages() > ONE;
  const needToShowUserCount = getTotalRecords() as number > ZERO;

  const getPagingContent = (): JSX.Element | null | string => {
    return getTotalPages() && needToShowPagingList
      ? <PagingPages pagingStore={pagingStore} onSelectPageCallback={onSelectPageCallback}/>
      : null;
  };
  return (
    <>
      {needToShowUserCount && <div className='paging-wrapper'>
        <PagingRecordsCounts
          currentPage={getCurrentPage()}
          totalRecords={getTotalRecords() as number}
          pageSize={getPageSize()}
        />
        <div className='paging-btns'>
          {getPagingContent()}
        </div>
      </div>}
    </>
  );
};

export default observer(Paging);